import React, { Component } from 'react';
import map from 'lodash/map';
import QuestionnaireAnswerRow from 'containers/Manage-Questionnaire/questionnaire/QuestionnaireAnswerRow';
import { Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import QuestionnaireAddAnswerDrawer from 'containers/Manage-Questionnaire/questionnaire/QuestionnaireAddAnswerDrawer';
import { Table, TableHeader } from 'components/styled-components';
import colors from 'utils/colors';
import {
  TableRow,
  AnswerWrapper,
  BlueText,
} from 'containers/Manage-Questionnaire/styled-components';

class QuestionnaireAnswers extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false, currentIndex: null };
  }
  openDrawer = () => this.setState({ isOpen: true });
  closeDrawer = () => this.setState({ isOpen: false });
  setIndex = currentIndex => this.setState({ currentIndex });

  render() {
    const { answers } = this.props;
    return (
      <React.Fragment>
        <Table>
          <tbody>
            <TableRow>
              <TableHeader>ID</TableHeader>
              <TableHeader>Answer</TableHeader>
              <TableHeader>Score</TableHeader>
              <TableHeader>Auto Fail</TableHeader>
              {/* Empty for edit button */}
              <TableHeader />
              {/* Empty for archive button */}
              <TableHeader />
            </TableRow>
            {map(answers, (answer, i) => {
              if (answer.answer === 'OPT_OUT') return;
              else {
                return (
                  <QuestionnaireAnswerRow
                    key={`${i}-${answer.answerID}`}
                    answer={answer}
                    //comparing length to 2 instead of 1 because the optout answer is hidden
                    isLastAnswer={answers.length === 2}
                    index={i}
                    currentIndex={this.state.currentIndex}
                    setIndex={this.setIndex}
                    {...this.props}
                  />
                );
              }
            })}
          </tbody>
        </Table>
        <AnswerWrapper
          cursor="pointer"
          onClick={this.openDrawer}
          background={colors.white}
        >
          <BlueText>
            <Icon icon={IconNames.ADD_TO_ARTIFACT} />
            ADD ANSWER
          </BlueText>
        </AnswerWrapper>
        <QuestionnaireAddAnswerDrawer
          isOpen={this.state.isOpen}
          closeDrawer={this.closeDrawer}
          {...this.props}
        />
      </React.Fragment>
    );
  }
}

export default QuestionnaireAnswers;
